import { HttpHeaders, HttpParams } from '@angular/common/http';

export interface RequestOptions {
  headers?: HttpHeaders;
  observe?: 'body';
  params?: HttpParams;
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
  body?: any;
}

export interface TshqRequestOptions extends RequestOptions {
  hideErrorAlert?: boolean;
  handledErrorCodes?: Array<string>;
}
